import Http from "../http";

class CompanyDetailServices{
    static async getCompanyDetails(){
        return Http.get('/companyDetails');
    }
    
    static async updateCompanyDetails(id,data){
        console.log("data in upodateCompanyDetails",data);
        return Http.update(`/companyDetails/edit/${id}`,data);
    }
    static async addCompanyDetails(data){
        console.log("========================================data in the riderServices",data)
        return Http.post('/companyDetails',data)
    }
    static async deleteCompanyDetails(id){
        return Http.delete(`/deleteCompanyDetails/${id}`);
    }


    
}
export default CompanyDetailServices